import React from 'react';
import TogetherBanner from 'components/togetherBanner';
import SEO from 'components/seo';

function ContactUs() {
  return (
    <>
      <SEO title="Contact Us" />
      <div className="wrapper">
        <div className="container-fluid py-6 mb-7">
          <div>
            <h1 className="font-weight-bolder underscore">Offices</h1>
          </div>
          <div className="row justify-content-center justify-content-lg-start">
            <div className="col-12 col-md-10 col-lg-6 mb-6">

              <img src="/assets/contact-us/london.jpg" alt="london" className="img-fluid" />

              <h4 className="font-weight-bolder my-3">London, United Kingdom</h4>

              <h5 className="my-4 font-weight-light">
                68 Pinner View, ground floor, <br className="d-none d-lg-block" />HA1 4QD, London,<br className="d-none d-lg-block" /> United Kingdom
              </h5>
              {/*<a
                target="_blank"
                className="d-flex justify-content-center align-items-center"
                href="https://www.google.com/maps/search/85+Great+Portland+street,+First+Floor,+W1W+7LT,+London,+United+Kingdom/@51.5184967,-0.1444056,17z/data=!3m1!4b1"
              >
                <img src="/assets/contact-us/london-map.jpg" alt="Athens" className="img-fluid" />
              </a>*/}
            </div>
            <div className="col-12 col-md-10 col-lg-6">
              <img src="/assets/contact-us/athens.jpg" alt="Athens" className="img-fluid" />
              <h4 className="font-weight-bolder my-3">Athens, Greece</h4>
              <h5 className="my-4 font-weight-light">

                23 Katechaki Street, <br className="d-none d-lg-block" />115 25, Athens, <br className="d-none d-lg-block" />Greece
              </h5>
              {/*<a
                target="_blank"
                className="d-flex justify-content-center align-items-center"
                href="https://www.google.com/maps/place/Katechaki+23,+Athina+115+25/@37.9940146,23.7721719,17z/data=!3m1!4b1!4m5!3m4!1s0x14a1980ff9e125fb:0xca2a89654989526d!8m2!3d37.9940146!4d23.7743606"
              >
                <img src="/assets/contact-us/athens-map.jpg" alt="Athens" className="img-fluid" />
              </a>*/}
            </div>
          </div>
        </div>
      </div>
      <TogetherBanner />
    </>
  );
}

export default ContactUs;
